import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const getMetric = async (metricName, patientId) => {
  const apiURL = patientId
    ? API_HOST + '/patient/' + patientId + '/metrics/' + metricName
    : API_HOST + '/metrics/' + metricName;
  const { token, userID } = useCurrentUser();
  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
